import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WINDOW', { providedIn: 'root', factory: () => window });

export const provideWindow = (window: Window) => {
  return { provide: WINDOW, useValue: window };
};
